import React from 'react'
import UserForm from "./UserForm";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";


const UserNew = () => {
  const navigate = useNavigate()

  const onCreate = async (user) => {
    user.fechaNacimiento = user.fechaNacimiento + "T00:00:00-05:00";
    await axios.post(Apis.PROD + '/usuario/register',user)
      .then(res => {
        successToast("Usuario registrado correctamente")
        navigate('/usuarios')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Usuarios' onClick={() => navigate('/usuarios')}/>
        <PageTitle title={'Usuario nuevo'}/>
      </PageSection>

      <PageSection>
        <UserForm value={{}} onSubmit={(user) => onCreate(user)}/>
      </PageSection>
    </PageContainer>
  )
}

export default UserNew;
